<template>
    <div class="container">
      <h2>Select Airport and QR Code</h2>
      <!-- Dropdown for Airports -->
      <div class="form-group">
        <label for="airportSelect">Select Airport:</label>
        <select id="airportSelect" v-model="selectedAirportId" @change="fetchQrCodes" class="form-control">
          <option v-for="airport in airports" :key="airport.id" :value="airport.id">
            {{ airport.name }}
          </option>
        </select>
      </div>
      <!-- Dropdown for QR Codes -->
      <div class="form-group" v-if="qrCodes.length > 0">
        <label for="qrCodeSelect">Select QR Code:</label>
        <select id="qrCodeSelect" v-model="selectedQrCodeId" @change="fetchQrImage" class="form-control">
          <option v-for="qrCode in qrCodes" :key="qrCode.id" :value="qrCode.id">
            {{ qrCode.name }}
          </option>
        </select>
      </div>
      <!-- Display QR Code Image -->
      <div v-if="qrImageUrl">
        <h3>QR Code Image: #{{ selectedQrCodeId }}  <span class="btn btn-sm btn-primary" @click="openSurveyInNewTab">Start Survey</span></h3>
        <img :src="qrImageUrl" alt="QR Code Image" class="img-fluid">
      </div>
    </div>
  </template>
  
  <script>
  import axiosInstance from '@/axiosInstance'; // Import the Axios instance
  
  export default {
    name: 'ShowQr',
    data() {
      return {
        airports: [],
        qrCodes: [],
        selectedAirportId: null,
        selectedQrCodeId: null,
        qrImageUrl: null
      };
    },
    mounted() {
      this.fetchAirports();
    },
    methods: {
      async fetchAirports() {
        try {
          const response = await axiosInstance.get('/public/airports');
          this.airports = response.data;
        } catch (error) {
          console.error('Error fetching airports:', error);
        }
      },
      async fetchQrCodes() {
        if (this.selectedAirportId) {
          try {
            const response = await axiosInstance.get(`/public/qr-codes/${this.selectedAirportId}`);
            this.qrCodes = response.data;
            this.selectedQrCodeId = null;
            this.qrImageUrl = null;
          } catch (error) {
            console.error('Error fetching QR codes:', error);
          }
        }
      },
      async fetchQrImage() {
        if (this.selectedQrCodeId) {
          try {
            // Directly setting the source of the image to the endpoint
            this.qrImageUrl = `${axiosInstance.defaults.baseURL}public/qr-codes/image/${this.selectedQrCodeId}`;
          } catch (error) {
            console.error('Error fetching QR image:', error);
          }
        }
      },

      openSurveyInNewTab() { 
        const qrcode = this.selectedQrCodeId; 
        const surveyUrl = `${window.location.origin}/?qrcode=${qrcode}`; window.open(surveyUrl, '_blank'); 
      },
    },
  };
  </script>
  
  <style scoped>
  .container {
    padding: 20px;
  }
  .form-group {
    margin-bottom: 15px;
  }
  .img-fluid {
    max-width: 100%;
    height: auto;
  }
  </style>
  